export enum LegacyReferralAreaEnum {
  All = 1,
  East = 2,
  South = 3,
  West = 4
}

export const LegacyReferralAreaOptions = [
{ id: 1, label: 'All' },
{ id: 2, label: 'East' },
{ id: 3, label: 'South' },
{ id: 4, label: 'West' }
];
